<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Observaciones</h4>
    <hr />

    <DataTable
      :data="observacions"
      :columns="columnas"
      idField="idObservacion"
      mensajeVacio="No hay registros de observaciones."
      :mostrarVer="false"
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idObservacion)"
      @delete="row => deleteObservacion(row.idObservacion)"
    />

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- Descripción -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Descripción</label></div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoObservacion.descripcion"
                    style="text-transform:uppercase"
                  />
                </div>
              </div>
            </div>
            <!-- Tipo -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Tipo</label></div>
                <div class="col-10">
                  <select class="form-select" v-model="datoObservacion.tipo">
                    <option disabled value="">Seleccione...</option>
                    <option value="M">Auditoría Médica</option>
                    <option value="D">Gestión Documental</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarObservacion"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarObservacion"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      observacions:    [],
      datoObservacion: {},
      titulo:          "",
      btnCrear:        false,
      btnEditar:       false,
      modalWindow:     true,
      idEmpresa:       0,
      idPerfil:        0,
    };
  },
  computed: {
    columnas() {
      const cols = [];
      if (this.idPerfil == 1) cols.push({ label: "Empresa", field: "empresaNombreCorto" });
      cols.push(
        { label: 'Descripción', field: 'descripcion' },
        { label: 'Tipo',        field: 'tipo', format: this.formatTipo },
      );
      return cols;
    },
  },	  
  mounted() {
    this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
    this.idPerfil       = Number(window.sessionStorage.getItem("idPerfil"));	
    this.getDataPaginaTodos();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    // ── Formato tipo ──────────────────────────────────────
    formatTipo(valor) {
      const tipos = { M: "Auditoría Médica", D: "Gestión Documental", C: "Comunes" };
      return tipos[valor] ?? valor;
    },
    // ── Carga de datos ────────────────────────────────────
    getDataPaginaTodos() {
      api.get(`/vwobservacions/idempresa/${this.idEmpresa}`)
        .then(r => { this.observacions = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar observaciones:", e));
    },
    // ── Validación ────────────────────────────────────────
    validarForm() {
      return validarForm(this.datoObservacion, ["descripcion"], ["descripcion"]);
    },
    // ── CRUD ──────────────────────────────────────────────
    async guardarObservacion() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoObservacion.idEmpresa = this.idEmpresa;
        await api.post("/observacions", this.datoObservacion);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Observación creada exitosamente." });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async actualizarObservacion() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/observacions", this.datoObservacion);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Observación actualizada exitosamente." });
        this.getDataPaginaTodos();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    async deleteObservacion(idObservacion) {
      const confirm = await Swal.fire({
        title: "¿Eliminar observación?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/observacions/" + idObservacion);
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },
    // ── Modales ───────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow     = true;
      this.datoObservacion = {};
      this.titulo          = "Crear observación estándar";
      this.btnCrear        = true;
      this.btnEditar       = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    async abrirModalEditar(idObservacion) {
      this.modalWindow = true;
      this.titulo      = "Editar observación estándar";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp           = await api.get("/vwobservacions/" + idObservacion);
        this.datoObservacion = resp.data;
      } catch (e) {
        console.error("Error al cargar observación:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
  },
};
</script>